var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWall1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 510.62 676.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9aadca;}.cls-2{fill:#788bb2;}.cls-3{fill:#6479a6;}.cls-4{opacity:0.7;}.cls-5{fill:#94a5ca;}.cls-6{fill:#8a9bbf;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Formulering_Stabilisering",
    "data-name": "Formulering & Stabilisering"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "252.7 527.87 251.61 371 264.81 378.62 264.81 522.04 252.7 527.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "510.62 11.95 26.43 169.28 26.6 385.33 510.62 228.06 510.62 11.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "510.62 676.78 510.62 460.78 0 165.97 0 189.88 0 381.97 252.7 527.87 251.61 371 319.19 410.26 319.19 566.26 510.62 676.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "510.62 0 13.18 161.63 26.43 169.28 510.62 11.95 510.62 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "510.62 448.67 13.25 161.67 0 165.97 510.62 460.62 510.62 448.67"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M218.92,410.45a4,4,0,0,0-4,4v41.07L151.1,418.67a4,4,0,1,0-4,6.93l67.82,39.16v21.69a4,4,0,0,0,8,0v-72A4,4,0,0,0,218.92,410.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M382.82,612.07h0a4,4,0,0,1-4-4l.66-188-99.89-57.67a4,4,0,1,1,4-6.93l101.9,58.83a4,4,0,0,1,2,3.48l-.67,190.33A4,4,0,0,1,382.82,612.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M403.43,626a4,4,0,0,1-4-4V487.54a4,4,0,0,1,8,0V622A4,4,0,0,1,403.43,626Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M218.12,316.27,25.27,204.93a4,4,0,0,0-4,6.93l67.3,38.85V437.48a4,4,0,0,0,8,0v-104l87.1,50.29a4,4,0,1,0,4-6.93l-91.1-52.6V255.33L214.12,323.2a4,4,0,1,0,4-6.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M510.62,481.87l-79.7-46a4,4,0,0,0-6,3.46V638a4,4,0,0,0,8,0V446.25l77.7,44.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M510.62,553.87l-47.78-27.58V496.53l47.78,27.58v-9.24l-49.78-28.74a4,4,0,0,0-6,3.47V656a4,4,0,0,0,8,0V535.53l47.78,27.58Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWall1);
export default __webpack_public_path__ + "static/media/wall-1.7ffb402b5aa9c497223b65de8d55b8da.svg";
export { ForwardRef as ReactComponent };